import { Skeleton } from "@particles/index"

import { Badge } from "@atoms"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"

import styles from "./JobPreviewLabels.module.scss"
import { JobPreviewLabelsProps } from "./JobPreviewLabels.types"

function WrappedLabelDisplay(props: { labels: JobPreviewLabelsProps["labels"] }) {
    const { labels } = props

    if (labels && labels.length > 0) {
        return (
            <div className={styles.labelsDisplay}>
                {labels.map((label) => (
                    <Badge key={label.id} colorScheme="gray" size="md" variant="subtle" type="default">
                        {label.name}
                    </Badge>
                ))}
            </div>
        )
    } else {
        return (
            <div className={styles.labelsDisplay}>
                <span className={styles.noLabels}>No labels</span>
            </div>
        )
    }
}

export default function JobPreviewLabels(props: JobPreviewLabelsProps) {
    const { labels } = props
    const { isLoading } = useJobPreviewCard()

    if (isLoading && !labels) {
        return (
            <div className={styles.labelsWrapper}>
                <Skeleton width={40} height={16} />
                <div className={styles.labelsSkeleton}>
                    <Skeleton width={60} height={16} />
                    <Skeleton width={60} height={16} />
                    <Skeleton width={60} height={16} />
                </div>
            </div>
        )
    }

    return (
        <div className={styles.labelsWrapper}>
            <p className={styles.labelsLabel}>Labels</p>
            <WrappedLabelDisplay labels={labels} />
        </div>
    )
}
